import { Box, Stack } from "@mui/material";
import { Header, SignOutModal } from "components/UI";
import { useUser } from "features/users";
import { useEffect } from "react";
import { useAuthUser, useSignOut } from "react-auth-kit";
import { Outlet } from "react-router-dom";
import { useChurchStore } from "../store";

export function ChurchProfileLayout() {
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const auth = useAuthUser();
  const signOut = useSignOut();

  const userQuery = useUser({
    churchId: selectedChurch?.id,
    userId: auth()?.id
  });

  useEffect(() => {
    if (userQuery.data && !userQuery.data?.result?.account_users?.[0]?.status) {
      signOut();
    }
  }, [userQuery.data]);

  return (
    <Stack sx={{ height: "100vh", overflowY: "auto" }}>
      <SignOutModal />
      <Header hasBackground />
      <Box
        sx={{
          p: 4
        }}
      >
        <Outlet />
      </Box>
    </Stack>
  );
}
